import React, { useState, useEffect, useRef } from "react";
import styles from "./BlogDetail.scss";
import SiteContainer from "components/homepage/SiteContainer";
import getStaticFile from "utils/getStaticFile";
import { truncateText } from "../../../utils/truncateText";
import { connect } from "react-redux";
import * as BlogActions from "actions/BlogActions";
import * as PostApi from "api/PostApi";
import ReCAPTCHA from "react-google-recaptcha";
import {
    EmailIcon,
    EmailShareButton,
    FacebookIcon,
    FacebookShareButton,
    TelegramIcon,
    TelegramShareButton,
    TwitterShareButton,
    WhatsappShareButton,
    WhatsappIcon,
    XIcon,
} from "react-share";
import { validateRecaptcha, joinNewsletter } from "api/SiteApi";
import "react-toastify/dist/ReactToastify.css";
import { toaster } from "utils/toaster";
import Video from "components/shared/elements/Video";

const PLAY_ICON = getStaticFile("img/play-icon.webp");
const AVATAR = getStaticFile("img/user_avatar.png");

const RECAPTCHA_SITE_KEY = window.ENV.RECAPTCHA_SITE_KEY;
const IS_LOGGED_IN = window.ENV.LOGGED_IN;

function getFileNameFromUrl(url) {
    const decodedUrl = decodeURIComponent(url);

    const matches = decodedUrl.match(/\/([^\/\?]+)(\?.*)?$/);

    if (matches && matches.length > 1) {
        return matches[1];
    }
    return null;
}

async function DownloadAction(props) {
    try {
        const response = await fetch(props.url);
        const blob = await response.blob();

        const link = document.createElement("a");
        const url = window.URL.createObjectURL(blob);
        link.href = url;
        link.download = getFileNameFromUrl(props.url);
        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    } catch (error) {
        toaster.error("There was an error downloading the file. Please try again later.");
    }
}

function DownloadPdfForm(props) {
    const onClick = () => {
        window.location.href = `/login/?next=/blog/${encodeURIComponent(props.slug)}`;
    };

    const handleDownloadFile = async (e) => {
        e.preventDefault();

        const token = await props.recaptchaRef.current.executeAsync();
        const recaptchaPass = await validateRecaptcha(token)
            .then((res) => {
                const recaptchaSuccess = res.body.success;
                if (!recaptchaSuccess) {
                    alert("Google says you're a ROBOT!!!\n\nIf you are... that's pretty cool that a Robot wants to play some Jazz.\n\nIf you're not a robot, hit 'OK' and try again.");
                    return false;
                }
                return true;
            })
            .catch((err) => {
                return false;
            });

        if (!recaptchaPass) {
            toaster.error("There was an error completing the reCAPTCHA. Please try again later.");
            return;
        }

        const email = e.target?.email?.value || document.getElementById("email")?.value || window.ENV.USER_EMAIL;
        const firstName = e.target?.firstName?.value || document.getElementById("firstName")?.value || window.ENV.USER_FIRST_NAME;
        const lastName = e.target?.lastName?.value || document.getElementById("lastName")?.value || window.ENV.USER_LAST_NAME;

        joinNewsletter({
            contactListId: props.contactList,
            email,
            firstName,
            lastName
        }).then(() => { });

        await DownloadAction({ url: props.url });
    };


    return (
        <form className={styles.downloadPdfForm} onSubmit={handleDownloadFile}>
            {
                props.isPremium && (
                    <>
                        <h2>This content is premium content</h2>
                        <h2>Upgrade your account to get the benefits</h2>
                        <div className={styles.getSupport}>
                            <button onClick={onClick}>Upgrade Now</button>
                        </div>
                    </>
                )
            }
            {
                !props.isPremium && (
                    <>
                        <h2>{`${props.header || 'Download the FREE PDF associated with this video'}`}</h2>
                        {
                            !IS_LOGGED_IN && (
                                <>
                                    <label htmlFor="firstName">First Name</label>
                                    <input type="text" id="firstName" required />
                                    <label htmlFor="lastName">Last Name</label>
                                    <input type="text" id="lastName" required />
                                    <label htmlFor="email">Email</label>
                                    <input type="email" id="email" required />
                                </>
                            )
                        }
                        <div>
                            <button type="submit">Download Now</button>
                        </div>
                    </>
                )
            }
        </form>
    );
}

function SubscribeForm(props) {
    const handleSubscribeEvent = async (e) => {
        e.preventDefault();

        const token = await props.recaptchaRef.current.executeAsync();
        const recaptchaPass = await validateRecaptcha(token)
            .then((res) => {
                const recaptchaSuccess = res.body.success;
                if (!recaptchaSuccess) {
                    alert("Google says you're a ROBOT!!!\n\nIf you are... that's pretty cool that a Robot wants to play some Jazz.\n\nIf you're not a robot, hit 'OK' and try again.");
                    return false;
                }
                return true;
            })
            .catch((err) => {
                return false;
            });

        if (!recaptchaPass) {
            toaster.error("There was an error completing the reCAPTCHA. Please try again later.");
            return;
        }

        const email = e.target?.email?.value || document.getElementById("email").value;
        const firstName = e.target?.firstName?.value || document.getElementById("firstName").value;
        const lastName = e.target?.lastName?.value || document.getElementById("lastName").value;

        joinNewsletter({
            contactListId: props.contactList,
            email,
            firstName,
            lastName
        }).then(() => {
            toaster.success("Thank you for subscribing to our newsletter!");
        }).catch(() => {
            toaster.error("There was an error subscribing to our newsletter. Please try again later.");
        });
    };

    return (
        <form className={styles.subscribeForm} onSubmit={handleSubscribeEvent}>
            <h2>Subscribe to join our newsletter</h2>
            <label htmlFor="firstName">First Name</label>
            <input type="text" id="firstName" required />
            <label htmlFor="lastName">Last Name</label>
            <input type="text" id="lastName" required />
            <label htmlFor="email">Email</label>
            <input type="email" id="email" required />
            <div>
                <button type="submit">Subscribe now</button>
            </div>
        </form>
    );
}


function BlogRelatedVideos({ blogs, blogId }) {
    const videoBlogs = blogs;
    if (!videoBlogs) return null;

    const watchBlogs = Object.values(videoBlogs)
        .filter(blog => blog.published === true && blog.id != blogId)
        .sort((a, b) => new Date(b.created) - new Date(a.created))
        .slice(0, 3);

    if (!watchBlogs.length) {
        return (
            <div className={styles.watchNext}>
                <h3>Related Videos</h3>
                <p>No related videos found</p>
            </div>
        );
    };

    const handleOnClick = (slug) => {
        window.location.href = `/blog/${encodeURIComponent(slug)}`;
    };

    return (
        <div className={styles.watchNext}>
            <h3>Related Videos</h3>
            {watchBlogs.map((blog, i) => (
                <div key={i} className={styles.watchNextCard} onClick={() => handleOnClick(blog.slug)}>
                    <div className={styles.titleCard}>
                        <h4>{truncateText(blog.title, 50)}</h4>
                    </div>
                    <div className={styles.imgCard}>
                        <img src={blog.socialShareImage?.file} alt={blog.title} className={styles.imgBlog} />
                        <img src={PLAY_ICON} alt="play icon" className={styles.playImage} />
                    </div>
                </div>
            ))}
        </div>
    );
}

function BlogWatchNextVideos({ blogs, blogId }) {
    const videoBlogs = blogs;
    if (!videoBlogs) return null;

    const watchBlogs = Object.values(videoBlogs)
        .filter(blog => blog.published === true)
        .sort((a, b) => new Date(b.created) - new Date(a.created));

    const currentBlogIndex = watchBlogs.findIndex(blog => blog.id == blogId);

    const hasPrevious = watchBlogs[currentBlogIndex - 1] !== undefined;
    const hasNext = watchBlogs[currentBlogIndex + 1] !== undefined;

    const previousBlog = hasPrevious ? watchBlogs[currentBlogIndex - 1] : null;
    const nextBlog = hasNext ? watchBlogs[currentBlogIndex + 1] : null;

    const handleOnClick = (slug) => {
        if (slug) {
            window.location.href = `/blog/${encodeURIComponent(slug)}`;
        }
    };

    return (
        <div className={`${styles.watchNextVideo}`}>
            <p className={`${styles.previousBlog}`} onClick={() => handleOnClick(previousBlog?.slug)}>
                See {hasPrevious ? 'Previous' : hasNext ? 'Next' : ''} Video
            </p>{' '}
            <p style={{ display: 'inline-block' }}>{hasNext ? '> ' : null}</p>
            {
                hasNext && (
                    <button onClick={() => handleOnClick(nextBlog?.slug)}>
                        <p>{hasNext ? nextBlog?.title : null}</p>
                    </button>
                )
            }
        </div>
    );
}

function HidePremiumDescription({ blogSlug }) {
    const onClick = () => {
        window.location.href = `/login/?next=/blog/${encodeURIComponent(blogSlug)}`;
    };

    return (
        <div className={styles.premiumDescription}>
            <div className={styles.premiumTextMessage}>
                <p>This content is premium content</p> <br />
                <p>Upgrade your account to get the benefits</p>
            </div>
            <div className={styles.getSupport}>
                <button onClick={onClick}>Upgrade Now</button>
            </div>
        </div>
    );
}

function HidePremiumDescriptionVideo({ blogSlug }) {
    const onClick = () => {
        window.location.href = `/login/?next=/blog/${encodeURIComponent(blogSlug)}`;
    };

    return (
        <div className={styles.premiumDescriptionVideo}>
            <div className={styles.premiumTextMessage}>
                <p>This content is premium content</p> <br />
                <p>Upgrade your account to get the benefits</p>
            </div>
            <div>
                <button onClick={onClick}>Upgrade Now</button>
            </div>
        </div>
    );
}

function RightSideContent({ sections }) {
    const scrollToSection = (id) => {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    };

    return (
        <div className={styles.contentTable}>
            <h2>Table of Content</h2>
            {sections.map((section, index) => (
                <p key={section.id}>{index + 1}. <span onClick={() => scrollToSection(section.id)} dangerouslySetInnerHTML={{ __html: section.title }}></span></p>
            ))}
        </div>
    );
}

function BlogDetail(props) {
    const [blogData, setBlogData] = useState({});
    const [postDetails, setPostDetails] = useState({});
    const [isTooltipVisible, setTooltipVisible] = useState(false);
    const [isPremiumLoggedIn, setIsPremiumLoggedIn] = useState(false);
    const [hidePremiumVideo, setHidePremiumVideo] = useState(false);
    const [noEmailClient, setNoEmailClient] = useState(false);
    const [initialWidth, setInitialWidth] = useState(null);
    const [initialOffsetTop, setInitialOffsetTop] = useState(null);
    const [initialLeft, setInitialLeft] = useState(0);
    const [isMobile, setIsMobile] = useState(false);

    const stickyRef = useRef(null);
    const recaptchaRef = useRef();

    useEffect(() => {
        const stickyElement = stickyRef.current;

        setInitialWidth(stickyElement.offsetWidth);
        setInitialOffsetTop(stickyElement.getBoundingClientRect().top + window.scrollY);
        setInitialLeft(stickyElement.getBoundingClientRect().left);

        const checkMobileView = () => {
            setIsMobile(window.innerWidth <= 900);
        };

        checkMobileView();

        window.addEventListener('resize', checkMobileView);

        return () => {
            window.removeEventListener('resize', checkMobileView);
        };
    }, []);

    useEffect(() => {
        props.loadBlog(props.blogId);
        props.loadBlogPages();

        const stickyElement = stickyRef.current;
        const footerElement = document.getElementById('footer-id');
        let isFooterReached = false;
        let stickyInitialTop = 0;

        const handleScroll = () => {
            if (isMobile) return;

            const scrollPosition = window.scrollY;
            const footerOffsetTop = footerElement.getBoundingClientRect().top + window.scrollY;
            const stickyHeight = stickyElement.offsetHeight;

            if (scrollPosition > initialOffsetTop && scrollPosition + stickyHeight < footerOffsetTop) {
                stickyElement.style.position = 'fixed';
                stickyElement.style.top = '0';
                stickyElement.style.left = `${initialLeft}px`;
                stickyElement.style.width = `${initialWidth}px`;
            }
            else if (scrollPosition + stickyHeight >= footerOffsetTop) {
                if (!isFooterReached) {
                    stickyInitialTop = scrollPosition - initialOffsetTop;
                    isFooterReached = true;
                }

                stickyElement.style.position = 'absolute';
                stickyElement.style.top = `${stickyInitialTop}px`;
                stickyElement.style.left = 0;
                stickyElement.style.width = `${initialWidth}px`;
                stickyElement.style.height = `${stickyHeight}px`;
            }
            else {
                if (isFooterReached && scrollPosition + stickyHeight < footerOffsetTop) isFooterReached = false;
                stickyElement.style.position = 'relative';
                stickyElement.style.left = '0';
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [initialWidth, initialOffsetTop, initialLeft, isMobile]);

    useEffect(() => {
        if (props.blogId) {
            if (!props.blog) {
                props.loadBlog(props.blogId);
            } else {
                setBlogData({
                    ...props.blog
                });

                if (props.blog.premium) {
                    const postId = props.blog.video.split('/').pop();

                    if (!IS_LOGGED_IN) {
                        setIsPremiumLoggedIn(true);
                    }

                    PostApi.loadPostDetailsWithOutAuth(postId).then((res) => {
                        setPostDetails(res.body);
                    });
                }
            }
        }
    }, [props.blog, props.blogId]);

    const handleSupportAction = () => {
        const mailtoTest = document.createElement('a');
        mailtoTest.href = 'mailto:test@example.com';

        if (mailtoTest.protocol === 'mailto:') {
            const email = 'matt@jazzwire.net';
            const subject = encodeURIComponent('Support Request from Jazz Vault Website');
            const body = encodeURIComponent('Please describe your issue or question here.');

            window.location.href = `mailto:${email}?subject=${subject}&body=${body}`;
        } else {
            setNoEmailClient(true);
        }
    };

    const formatDate = (date) => {
        if (!date) return;
        const dateObj = new Date(date);
        const options = { year: 'numeric', month: 'long' };
        return new Intl.DateTimeFormat('en-US', options).format(dateObj);
    };

    const getYouTubeVideoId = (url) => {
        if (!url) return null;
        const videoIdMatch = url.match(/\/embed\/([a-zA-Z0-9_-]+)/);
        return videoIdMatch ? videoIdMatch[1] : null;
    };

    const toggleTooltip = (e) => {
        e.stopPropagation();
        setTooltipVisible((prevVisible) => !prevVisible);
    };

    const extractHeaders = (html, prefix = "section") => {
        const headers = [];
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const h2Elements = doc.querySelectorAll("h2");

        h2Elements.forEach((header, index) => {
            if (!header.id) {
                header.id = `${prefix}-${index}`;
            }
            headers.push({
                id: header.id,
                title: header.textContent.trim(),
            });
        });

        return headers;
    };

    function addIdsToHeaders(html, prefix = "section") {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const headers = doc.querySelectorAll("h2");

        headers.forEach((header, index) => {
            header.id = `${prefix}-${index}`;
        });

        return doc.body.innerHTML;
    }

    function splitHtmlAtFirstHeader(html) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const body = doc.body;
    
        let visible = '';
        let hidden = '';
        let foundFirstH2 = false;
    
        body.childNodes.forEach(node => {
            if (!foundFirstH2) {
                if (node.tagName === 'H2') {
                    foundFirstH2 = true;
                    hidden += node.outerHTML;
                } else {
                    visible += node.outerHTML || node.textContent;
                }
            } else {
                hidden += node.outerHTML || node.textContent;
            }
        });
    
        return { visibleText: visible, hiddenText: hidden };
    }
    

    const shareUrl = window.location.href;
    const title = blogData.title;
    const fullText = addIdsToHeaders(blogData.body);

    let visibleText = fullText;
    let hiddenText = null;

    if (blogData.premium && isPremiumLoggedIn) {
        const split = splitHtmlAtFirstHeader(fullText);
        visibleText = split.visibleText;
        hiddenText = split.hiddenText;
    }
    

    const visibleHeaders = extractHeaders(visibleText);
    const hiddenHeaders = extractHeaders(hiddenText);

    const sections = [...visibleHeaders, ...hiddenHeaders].map(({ id, title }) => ({
        id,
        title,
    }));

    return (
        <SiteContainer minimal>
            <div className={`container ${styles.root}`}>
                <header className={styles.header}>
                    <p>The Jazz Vault: Unlocking Improvisational Secrets</p>
                </header>
                <div className={`${styles.contentSide}`}>
                    <section className={`${styles.blogSide}`}>
                        <div className={`${styles.blogVideo}`}>
                            {
                                !blogData.premium && (
                                    <iframe src={blogData.video} title={blogData.title} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
                                )
                            }
                            {
                                blogData.premium && (
                                    <>
                                        {hidePremiumVideo && <HidePremiumDescriptionVideo blogSlug={blogData.slug} />}
                                        <div className={`${hidePremiumVideo ? styles.premiumVideo : ''}`}>
                                            <Video
                                                muxPlaybackId={postDetails?.video?.muxPlaybackId}
                                                thumbnailTimecode={postDetails?.video?.thumbnailTimecode || null}
                                                analyticsData={{
                                                    title: postDetails?.title,
                                                }}
                                                isPremiumVideo={isPremiumLoggedIn}
                                                onPremiumVideoPause={() => setHidePremiumVideo(true)}
                                            />
                                        </div>
                                    </>
                                )
                            }
                        </div>
                        <div className={`${styles.breadCrumbs}`}>
                            <p><a href="/blog/" style={{ textDecoration: 'none' }}>The Jazz Vault</a> {'>'} {blogData.title}</p>
                        </div>
                        <hr />
                        <div className={`${styles.blogInfo}`} id="title">
                            <div>
                                <img src={blogData.lastEditedBy?.avatar || AVATAR} alt="blog" />
                            </div>
                            <div style={{ maxWidth: '830px' }}>
                                <h1>{blogData.title}</h1>
                                <p>{blogData.lastEditedBy?.firstName} {blogData.lastEditedBy?.lastName} <span>{formatDate(blogData.created)}</span></p>
                            </div>
                            <div className={`${styles.blogShareContent}`}>
                                <span className={`${styles.tooltip}`} onClick={toggleTooltip}>
                                    <i className="fa fa-share" style={{ marginRight: 2 }} />
                                    Share
                                    {isTooltipVisible && (
                                        <span className={`${styles.tooltiptext}`}>
                                            <FacebookShareButton url={shareUrl}>
                                                <FacebookIcon size={32} round />
                                            </FacebookShareButton>
                                            <TwitterShareButton url={shareUrl} title={title}>
                                                <XIcon size={32} round />
                                            </TwitterShareButton>
                                            <TelegramShareButton url={shareUrl} title={title}>
                                                <TelegramIcon size={32} round />
                                            </TelegramShareButton>
                                            <WhatsappShareButton url={shareUrl} title={title} separator=":: ">
                                                <WhatsappIcon size={32} round />
                                            </WhatsappShareButton>
                                            <EmailShareButton url={shareUrl} subject={title} body="body">
                                                <EmailIcon size={32} round />
                                            </EmailShareButton>
                                        </span>
                                    )}
                                </span>
                                <span><i className="fa fa-heart" style={{ marginRight: 2 }} /> <a href={`https://www.youtube.com/watch?v=${getYouTubeVideoId(blogData.video)}`} target="_blank" rel="noopener noreferrer">Love</a></span>
                            </div>
                        </div>
                        <hr />
                        <div className={`${styles.blogText}`} id="mainContent">
                            {isPremiumLoggedIn && <HidePremiumDescription blogSlug={blogData.slug} />}

                            <div
                                dangerouslySetInnerHTML={{ __html: visibleText }}
                                className={styles.visibleText}
                            ></div>

                            <div
                                dangerouslySetInnerHTML={{ __html: hiddenText }}
                                className={isPremiumLoggedIn ? styles.hiddenText : ''}
                            />

                            {
                                (blogData?.fileDownload?.file && !isPremiumLoggedIn) && (
                                    <div>
                                        <button onClick={() => DownloadAction({ url: blogData?.fileDownload?.file })} className={`${styles.ctaDownload}`}>Download Now</button>
                                    </div>
                                )
                            }
                        </div>
                        {!isPremiumLoggedIn && <BlogWatchNextVideos blogs={props.blogPages} blogId={props.blogId} />}
                    </section>
                    <div className={`${styles.infoSide}`}>
                        <section ref={stickyRef}>
                            {
                                sections.length > 0 && <RightSideContent sections={sections} />
                            }
                            {
                                blogData?.fileDownload?.file && <DownloadPdfForm url={blogData?.fileDownload?.file}
                                    header={blogData?.downloadHeader}
                                    recaptchaRef={recaptchaRef}
                                    contactList={blogData?.contactList}
                                    isPremium={isPremiumLoggedIn}
                                    slug={blogData?.slug} />
                            }
                            {
                                !blogData?.fileDownload?.file && <SubscribeForm recaptchaRef={recaptchaRef} contactList={blogData?.contactList} />
                            }
                            <div>
                                <ReCAPTCHA
                                    ref={recaptchaRef}
                                    size="invisible"
                                    sitekey={RECAPTCHA_SITE_KEY}
                                />
                            </div>
                            <hr />
                            <BlogRelatedVideos blogs={props.blogPages} blogId={props.blogId} />
                            <hr />
                            <div className={styles.getSupport}>
                                <h4>Need help getting started with JazzWire?</h4>
                                <button onClick={handleSupportAction}>Get support</button>

                                {noEmailClient && (
                                    <div style={{ marginTop: '10px', color: 'red' }}>
                                        It seems like you don’t have an email client configured. Please contact us directly at: {' '}
                                        <a href="mailto:matt@jazzwire.net">matt@jazzwire.net</a>
                                    </div>
                                )}
                            </div>
                        </section>
                    </div>
                </div>
            </div >
        </SiteContainer >
    );
};

BlogDetail.propTypes = {
};

export default connect(
    (state, ownProps) => {
        const blogId = ownProps.blogId;

        return {
            blogId,
            blog: state.entities.blogPages[blogId],
            blogPages: state.entities.blogPages,
        };
    },
    (dispatch) => ({
        loadBlog: (blogId) => dispatch(BlogActions.loadBlogPage(blogId)),
        loadBlogPages: () => dispatch(BlogActions.loadBlogPages()),
    })
)(BlogDetail);
